export type BedCategory = {
  readonly id: number;
  readonly name: string;
  readonly capacity: number;
  readonly priority: number;
  readonly type: string;
};

export function createBedCategory(values: unknown): BedCategory {
  const { id, name, capacity, priority, type } = values as BedCategory;

  return {
    id,
    name,
    capacity,
    priority,
    type,
  };
}
